'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _withReduxForm = require('../../libs/hocs/withReduxForm');

var _withReduxForm2 = _interopRequireDefault(_withReduxForm);

var _Lookup = require('../Lookup');

var _Lookup2 = _interopRequireDefault(_Lookup);

var _locationIcon = require('./icons/locationIcon');

var _locationIcon2 = _interopRequireDefault(_locationIcon);

var _poweredByGoogle = require('./icons/poweredByGoogle');

var _poweredByGoogle2 = _interopRequireDefault(_poweredByGoogle);

var _utils = require('../../libs/utils');

var _getSuggestions = require('./helpers/getSuggestions');

var _getSuggestions2 = _interopRequireDefault(_getSuggestions);

var _getSearchForOption = require('./helpers/getSearchForOption');

var _getSearchForOption2 = _interopRequireDefault(_getSearchForOption);

var _getFormattedValue = require('./helpers/getFormattedValue');

var _getFormattedValue2 = _interopRequireDefault(_getFormattedValue);

var _selectedLocationIcon = require('./icons/selectedLocationIcon');

var _selectedLocationIcon2 = _interopRequireDefault(_selectedLocationIcon);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

var _getSearchParams = require('./helpers/getSearchParams');

var _getSearchParams2 = _interopRequireDefault(_getSearchParams);

var _proptypes = require('./proptypes');

var CustomPropTypes = _interopRequireWildcard(_proptypes);

require('./styles.css');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var PlacesLookupComponent = function (_Component) {
  _inherits(PlacesLookupComponent, _Component);

  function PlacesLookupComponent(props) {
    _classCallCheck(this, PlacesLookupComponent);

    var _this = _possibleConstructorReturn(this, (PlacesLookupComponent.__proto__ || Object.getPrototypeOf(PlacesLookupComponent)).call(this, props));

    _this.lookupId = (0, _utils.uniqueId)('gaddrlookup-input');
    _this.initialized = false;
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSearch = _this.handleSearch.bind(_this);
    _this.placesServiceRef = _react2.default.createRef();
    _this.state = {
      isSearching: false,
      // TODO: remove
      places: [],
      suggestions: []
    };
    return _this;
  }

  _createClass(PlacesLookupComponent, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref) {
      var prevIsScriptLoaded = _ref.isScriptLoaded; // TODO: change this please, keep isInitialized as an state and don't
      // render anything until the
      // component is initialized

      var _props = this.props,
          isScriptLoaded = _props.isScriptLoaded,
          isScriptLoadSucceed = _props.isScriptLoadSucceed;

      if (!prevIsScriptLoaded && isScriptLoaded && isScriptLoadSucceed) {
        this.initComponent();
      }
    }
  }, {
    key: 'getContainerClassName',
    value: function getContainerClassName() {
      var className = this.props.className;
      return (0, _classnames2.default)('rainbow-google-address-lookup_container', className);
    }
  }, {
    key: 'getPlaceInfo',
    value: function getPlaceInfo(placeId) {
      var _this2 = this;

      this.setState({
        isSearching: true
      });
      return new Promise(function (resolve, reject) {
        _this2.placesService.getDetails({
          placeId: placeId
        }, function (details, status) {
          _this2.setState({
            isSearching: false
          });

          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            return resolve(details);
          }

          return reject(status);
        });
      });
    }
  }, {
    key: 'initComponent',
    value: function initComponent() {
      this.autocompleteService = new window.google.maps.places.AutocompleteService();
      this.placesService = new window.google.maps.places.PlacesService(this.placesServiceRef.current);
      this.initialized = true;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(option) {
      var onChange = this.props.onChange;

      if (!option) {
        return onChange(null);
      }

      if (!option.id) {
        return onChange(option.data);
      }

      var places = this.state.places;
      var placePrediction = places.find(function (place) {
        return place.place_id === option.id;
      });
      return this.getPlaceInfo(option.id).then(function (result) {
        var resultValue = Object.assign(result, {
          predictionInfo: placePrediction
        });
        return onChange(resultValue);
      }).catch(function () {
        var resultValue = placePrediction;
        return onChange(resultValue);
      });
    }
  }, {
    key: 'handleSearch',
    value: function handleSearch(value) {
      var _this3 = this;

      if (!this.initialized) return;

      if (value) {
        this.searchGooglePlaces(value).then(function (results) {
          return _this3.processSearchResults(results, value);
        }).catch(function () {
          return _this3.handleError(value);
        });
      } else if (!value) {
        this.clear();
      }
    }
  }, {
    key: 'searchGooglePlaces',
    value: function searchGooglePlaces(needle) {
      var _this4 = this;

      var searchOptions = this.props.searchOptions;
      var searchParams = (0, _getSearchParams2.default)(searchOptions);
      this.setState({
        isSearching: true
      });
      return new Promise(function (resolve, reject) {
        _this4.autocompleteService.getPlacePredictions(_extends({}, searchParams, {
          input: needle
        }), function (predictions, status) {
          _this4.setState({
            isSearching: false
          });

          if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
            return reject(status);
          }

          return resolve(predictions);
        });
      });
    }
  }, {
    key: 'processSearchResults',
    value: function processSearchResults(results, searchValue) {
      this.setState({
        places: results,
        suggestions: (0, _getSuggestions2.default)(results, searchValue)
      });
    }
  }, {
    key: 'handleError',
    value: function handleError(searchValue) {
      this.setState({
        places: [],
        suggestions: [(0, _getSearchForOption2.default)(searchValue)]
      });
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.setState({
        places: [],
        suggestions: []
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          label = _props2.label,
          error = _props2.error,
          readOnly = _props2.readOnly,
          placeholder = _props2.placeholder,
          disabled = _props2.disabled,
          tabIndex = _props2.tabIndex,
          required = _props2.required,
          id = _props2.id,
          name = _props2.name,
          value = _props2.value,
          hideLabel = _props2.hideLabel,
          onClick = _props2.onClick,
          onBlur = _props2.onBlur;
      var _state = this.state,
          isSearching = _state.isSearching,
          suggestions = _state.suggestions;
      var options = suggestions.length > 0 ? suggestions : null;
      return _react2.default.createElement('div', {
        id: id,
        style: style,
        className: this.getContainerClassName()
      }, _react2.default.createElement(_Lookup2.default, {
        id: this.lookupId,
        name: name,
        label: label,
        debounce: true,
        isLoading: isSearching,
        placeholder: placeholder,
        options: options,
        hideLabel: hideLabel,
        readOnly: readOnly,
        required: required,
        tabIndex: tabIndex,
        disabled: disabled,
        value: (0, _getFormattedValue2.default)(value, false, _react2.default.createElement(_selectedLocationIcon2.default, null)),
        onChange: this.handleChange,
        onSearch: this.handleSearch,
        onClick: onClick // fix focus problem when used with redux form
        // onFocus={onFocus}
        ,
        onBlur: onBlur,
        error: error,
        icon: _react2.default.createElement(_locationIcon2.default, null)
      }), _react2.default.createElement(_RenderIf2.default, {
        isTrue: !error
      }, _react2.default.createElement('div', {
        className: 'rainbow-google-address-lookup_powered-by-google-container'
      }, _react2.default.createElement(_poweredByGoogle2.default, {
        className: 'rainbow-google-address-lookup_powered-by-google-logo'
      }))), _react2.default.createElement('div', {
        ref: this.placesServiceRef
      }));
    }
  }]);

  return PlacesLookupComponent;
}(_react.Component);

PlacesLookupComponent.propTypes = {
  isScriptLoaded: _propTypes2.default.bool.isRequired,
  isScriptLoadSucceed: _propTypes2.default.bool.isRequired,
  searchOptions: CustomPropTypes.searchOptionsShape,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  hideLabel: _propTypes2.default.bool,
  readOnly: _propTypes2.default.bool,
  value: _propTypes2.default.oneOfType([CustomPropTypes.predictionShape, CustomPropTypes.placeDetailsShape, _propTypes2.default.string]),
  name: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  disabled: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  style: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  // onFocus: PropTypes.func,
  onBlur: _propTypes2.default.func
};
PlacesLookupComponent.defaultProps = {
  searchOptions: undefined,
  value: undefined,
  name: undefined,
  placeholder: null,
  required: false,
  readOnly: false,
  error: null,
  disabled: false,
  onChange: function onChange() {},
  onClick: function onClick() {},
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  tabIndex: undefined,
  label: undefined,
  className: undefined,
  style: undefined,
  id: undefined,
  hideLabel: false
};
exports.default = (0, _withReduxForm2.default)(PlacesLookupComponent);
exports.Component = PlacesLookupComponent;